<div class="modal-header">
  <h5 class="modal-title">Rule Violations</h5>
</div>

<div class="modal-body">
  @if (ruleViolations.documentRules.length > 0) {
    <div
      class="document-rule-section"
      >
      <img src="assets/images/fa-exclamation-circle-o.png" class="ms-2 float-start exclamation-img" alt="Exclamation point" />
      <span class="ms-3">
        Document(s) need attention. Open the
        <span class="document-rule-text-link" (click)="openDigiDocs()">document editor</span>
        and fix any errors to continue.
      </span>
    </div>
  }
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn-primary"
    (click)="closeModal()"
    >
    Close
  </button>
</div>
